@if (src() && !failed()) {
  <img class="avatar__image" [src]="src()" [alt]="alt()" (error)="onError()" />
} @else {
  <mat-icon class="avatar__icon" aria-hidden="true">{{ fallbackIcon() }}</mat-icon>
}
